import axios from "axios";
import { Base_URL } from "../url";
 
// GET Working Days
export const fetchWorkingDays = async (organisationId) => {
  try {
    const response = await axios.get(
      `${Base_URL}/SalaryProcess/Working_DaysMaster/id?id=${organisationId}`,
     
    );
 
    return response.data;
  } catch (error) {
    throw error.response?.data || "Error fetching working days!";
  }
};
 
// POST Working Days
export const addWorkingDay = async (payload) => {
  try {
    const response = await axios.post(
      `${Base_URL}/SalaryProcess/AddWorkingDays`,
      payload
    );
 
    return response.data;
  } catch (error) {
    throw error.response?.data || "Error adding working days!";
  }
};
 